module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7v72fCFo53cPzhs6ifkO8J-c9b6629eb0588298426847f0d07414e6.jpg";